import { render } from "./SelectionsOrder.vue?vue&type=template&id=25e52a8e&scoped=true"
import script from "./SelectionsOrder.vue?vue&type=script&lang=js"
export * from "./SelectionsOrder.vue?vue&type=script&lang=js"

import "./SelectionsOrder.vue?vue&type=style&index=0&id=25e52a8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e52a8e"]])

export default __exports__